<template>
    <div class="">
    <section>
        <div class="columns">
            <div class="column">
                <h3 class="title is-4">Account settings</h3>
                <div class="tile is-ancestor">
    <div class="tile is-6 is-vertical is-parent">
    <div class="tile is-child box" v-if="currentUser && currentUser.plan">
      
      
        <div class="block">
                            <img
                            class="image is-64x64"
                            :src="(currentUser.photoURL)?currentUser.photoURL : `https://ui-avatars.com/api/?name=${currentUser.displayName}&background=3482F6&color=fff`"
                            alt="User avatar"
                            :rounded="true"
                            >
                            <br>
                            <b-field label="Name">
                                <b-input v-model="currentUser.displayName"></b-input>
                            </b-field>

                            <b-field label="Workspace">
                                <b-input v-model="currentUser.organization"></b-input>
                            </b-field>
                            
                            <b-field label="E-mail">
                                <b-input v-model="currentUser.email" disabled></b-input>
                            </b-field>
                            <b-button @click="resetPassword" class="button is-pulled-right" type="reset">Reset password</b-button>
                            <br>
                            <b-field label="UserID">
                                <b-input v-model="currentUser.id" disabled></b-input>
                            </b-field>

                            

                            <!-- <b-field label="Verified">
                                <b-input v-model="currentUser.verified" disabled></b-input>
                            </b-field> -->
                            <!-- 
                            <b-field label="Created at">
                                {{ currentUser.createdAt | dateFormat }}
                            </b-field> -->
                            <b-button @click="updateUserInfo" class="button is-pulled-right">Update</b-button>
                        </div>
    
    </div>
</div>
<div class="tile is-6 is-vertical is-parent">
    <div class="tile is-child box" v-if="currentUser && currentUser.plan">
      
        <div class="block">
                            <h4 class="title is-5">Your API Key</h4>
                            <b-field label="API Key">
                                <b-input :value="getApiKey()" disabled></b-input>
                            </b-field>
                        </div>
    
    </div>
</div>

<div class="tile is-4 is-vertical is-parent" v-if="0">
    <div class="tile is-child box" v-if="currentUser && currentUser.plan">

<div class="block">


<!-- <b-field label="Organization name">
    <b-input :disabled="currentUser.id != currentOrg.id" v-model="currentOrg.organization" @input="renameOrg"></b-input>
</b-field> -->

<b-field v-if="currentUser.id == currentOrg.id" label="Invite a collaborator" :label-position="labelPosition">
    <b-input v-model="newMemberEmail" expanded placeholder="Type the email"  type="search"></b-input>
    <b-select v-model="newMemberPermission" placeholder="Select a permission">
        <option
            value="editor"
            key="editor">
            Editor
        </option>
    </b-select>
    <p class="control">
        <b-button @click="addMember" class="button is-primary">Invite</b-button>
    </p>
</b-field>


<b-field label="Current collaborators">
</b-field>

<b-field :label="(member.signup?'':'')" v-bind:key="member.email" v-for="member in [...[{'email': currentOrg.email, 'permission': 'admin', 'signup': true}], ...getMembers()]">
    <b-input disabled expanded :value="`${member.email} ${(member.email == currentUser.email?'(You)':'')}`" type="search"></b-input>
    <b-select disabled placeholder="Permission" :value="member.permission">
        <option
            :value="member.permission"
            :key="member.permission">
            {{ member.permission }}
        </option>
    </b-select>
    <p class="control" v-if="member.email != currentUser.email || currentUser.id == currentOrg.id">
        <b-button :disabled="member.email == currentUser.email || currentUser.id != currentOrg.id" @click="removeMember(member.email)" class="button">Remove</b-button>
    </p>
</b-field>

</div>

</div></div>
</div>
            
        </div>
        
        </div>
    </section>

    </div>
</template>
<script>

   export default {
     props: ["currentUser", "currentOrg", "datasetsTotal", "modelsTotal"],
     name: "Settings",
     data: function() {
    return {
        all_users_api_key: 'Z0CDIgI42M5hggX0bpBB61UZswN4NiHNaqqsFIWd',
        organization: null,
        access: ['editor', 'admin'],
        newMemberEmail: null,
        newMemberPermission: 'editor',
        labelPosition: 'left'
    }},
    filters: {
        dateFormat: function (d) {
            return d.toDate().toLocaleString('en-US', 
            { timeZone: 'UTC', hour: 'numeric', minute: 'numeric', day: 'numeric', month: 'numeric', year: 'numeric' })
        }
    },
    methods: {
        getMembers(){
            if (this.currentOrg.members){
                return this.currentOrg.members
            } else {
                this.currentOrg.members = []
                return []
            }
        },
        getApiKey(){
            if(this.currentOrg && this.currentOrg.apiKey != undefined){
              return this.currentOrg.apiKey
            } else {
              return this.all_users_api_key
            }
         },
         resetPassword(){
            var url = 'https://app.metatext.ai/'
            var env = process.env.VUE_APP_ENV_NAME
            if(env != 'prod'){
                url = 'https://dev-app.metatext.ai/'
            }
            const actionCodeSettings = {
                url: url,
                handleCodeInApp: false
            }
            const email = this.currentUser.email
            this.$firebase.auth().sendPasswordResetEmail(email, actionCodeSettings)
            .then(() => {
                this.$buefy.snackbar.open({
                message: "Password reset email sent",
                type: "is-success",
                position: "is-top-left",
                duration: 3000
            });

            })
            .catch((error) => {
                console.log(error.code);
                console.log(error.message);
                // ..
            });
         },
         updateUserInfo(){
            let toUpdate = {
                userId: this.$firebase.auth().currentUser.uid,
                update: {
                    displayName: this.currentUser.displayName,
                    organization: this.currentUser.organization
                }
            }

            this.$store.dispatch("updateUser", 
                toUpdate
            );

            this.$buefy.snackbar.open({
                message: "User info updated",
                type: "is-white",
                position: "is-bottom-left",
                duration: 3000
            });
         },
         renameOrg(){

            let toUpdate = {
                organization: this.currentOrg.organization,
                organizationId: (this.currentOrg) ? this.currentOrg.id : this.$firebase.auth().currentUser.uid,
            }

            this.$store.dispatch("updateOrganization", 
                toUpdate
            );
         },
         addMember(){
            /** Member
             * email: str
             * permission: str
             * signup: bool
             * invited_at: date
             ***/
            let member = {
                email: this.newMemberEmail,
                permission: this.newMemberPermission,
                signup: false
            }

            if (this.currentOrg.members){
                this.currentOrg.members.push(member)
            } else {
                this.currentOrg.members = []
                this.currentOrg.members.push(member)
            }
            

            let currentUserName = (this.currentUser.displayName)? this.currentUser.displayName : this.currentUser.email
            let currentUserId = this.currentUser.id

            // check if any user has this email

            let toUpdate = {
                organizationId: this.currentOrg.id,
                members: this.currentOrg.members
            }

            this.$store.dispatch("updateMembers", 
                toUpdate
            );

            this.$store.dispatch("inviteMember", 
                currentUserId,
                currentUserName,
                this.newMemberEmail
            );

            
         },
         editMember(){},
         removeMember(removeMemberEmail){
            this.currentOrg.members = this.currentOrg.members.filter( m => m.email != removeMemberEmail)

            let toUpdate = {
                userId: this.$firebase.auth().currentUser.uid,
                organization: this.currentOrg.organization,
                members: this.currentOrg.members
            }

            this.$store.dispatch("updateMembers", 
                toUpdate
            );

         }
    }
   };
</script>